import { TableLayoutContract, TableSlimModel } from 'models'
import { IAction } from 'types/storeTypes'
import { Dictionary } from 'utilities/typeUtility/typeUtility'
import {
    PATCH_TABLE_SERVICE_TABLE_GUEST_COUNT,
    SET_SELECTED_TABLE_LAYOUT_ID,
    SET_TABLE_SERVICE_ORDER_STOCK_AVAILABILITY_ERROR,
    SET_TABLE_SERVICE_TABLE_LAYOUT,
    SET_TABLE_SERVICE_TEMP_TABLE_STATUS,
} from 'store/actions/tableService.action'

interface ITableServiceState {
    selectedLayoutID: string
    tableLayout?: TableLayoutContract
    tempTableStatus: TableSlimModel[]
    tableGuestCount: Dictionary<number>
    orderStockAvailabilityError?: unknown
}

const initialState: ITableServiceState = {
    selectedLayoutID: '',
    tableLayout: undefined,
    tempTableStatus: [],
    tableGuestCount: {},
    orderStockAvailabilityError: undefined,
}

function tableServiceReducer(
    state: ITableServiceState = initialState,
    action: IAction,
): ITableServiceState {
    switch (action.type) {
        case SET_SELECTED_TABLE_LAYOUT_ID: {
            return {
                ...state,
                selectedLayoutID: action.payload,
            }
        }
        case SET_TABLE_SERVICE_TABLE_LAYOUT: {
            return {
                ...state,
                tableLayout: action.payload,
            }
        }
        case SET_TABLE_SERVICE_TEMP_TABLE_STATUS: {
            return {
                ...state,
                tempTableStatus: action.payload,
            }
        }
        case PATCH_TABLE_SERVICE_TABLE_GUEST_COUNT: {
            return {
                ...state,
                tableGuestCount: action.payload,
            }
        }
        case SET_TABLE_SERVICE_ORDER_STOCK_AVAILABILITY_ERROR: {
            return {
                ...state,
                orderStockAvailabilityError: action.payload,
            }
        }
        default:
            return state
    }
}

export default tableServiceReducer
